import BasePage from '../../components/base-page/base-page';
import RangeSlider from '../../components/range-slider/range-slider';
import ContactModal from '../../components/contact-modal/contact-modal';
import type { UiElement } from '../../../shared/ui-element/ui-element';
import type { BaseModal } from '../../components/base-modal/base-modal';

import './partner-program.scss';


const RANGE_DEFAULT_VALUE = 10;

class PartnerProgramPage extends BasePage {
  ui = {
    rangeValue: '.js-range-value',
    marginValue: '.js-margin-value',
  };

  slider = new RangeSlider({
    defaultValue: RANGE_DEFAULT_VALUE,
    changeHandler: this.changeMarginValue.bind(this),
  });

  contactModal = new ContactModal();

  rangeValueMaxClass = 'partner-program-calculator__value_max';

  onInit() {
    super.onInit();
    this.slider.init();
    (this.contactModal as BaseModal).init();
  }

  changeMarginValue(value) {
    let margin = 50;
    if (value > 99 && value < 300) margin = 59;
    if (value > 299 && value < 751) margin = 63;
    if (value > 750 && value < 1150) margin = 68;
    if (+value === 1150) {
      margin = 77;
      (this.ui.rangeValue as unknown as HTMLElement).classList.add(this.rangeValueMaxClass);
    } else {
      (this.ui.rangeValue as unknown as HTMLElement).classList.remove(this.rangeValueMaxClass);
    }

    (this.ui.marginValue as unknown as HTMLElement).innerHTML = `${margin}%`;
  }
}

export default PartnerProgramPage;

(PartnerProgramPage as UiElement).initOnDomLoaded();
